/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectTaskDependencyCommand } from '../../models/create-project-task-dependency-command';
import { CreateProjectTaskDependencyCommandResult } from '../../models/create-project-task-dependency-command-result';

export interface ApiProjectTaskDependencyCreateProjectTaskDependencyPost$Params {
      body?: CreateProjectTaskDependencyCommand
}

export function apiProjectTaskDependencyCreateProjectTaskDependencyPost(http: HttpClient, rootUrl: string, params?: ApiProjectTaskDependencyCreateProjectTaskDependencyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectTaskDependencyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTaskDependencyCreateProjectTaskDependencyPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectTaskDependencyCommandResult>;
    })
  );
}

apiProjectTaskDependencyCreateProjectTaskDependencyPost.PATH = '/api/ProjectTaskDependency/CreateProjectTaskDependency';
